import { render, staticRenderFns } from "./pnl_program_step2.vue?vue&type=template&id=2b2de2ca"
import script from "./pnl_program_step2.vue?vue&type=script&lang=js"
export * from "./pnl_program_step2.vue?vue&type=script&lang=js"
import style0 from "./pnl_program_step2.vue?vue&type=style&index=0&id=2b2de2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports